import { Box, Button, Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { MapActions } from '../../../../../store/Map'
import { IWaterSystemWCoordinates } from '../../../../../types'
import { getViolationColor } from '../../../../../utils/waterSystemHelper'
import { ExpandIcon, UsersGroupIcon } from '../../../../icons'
import { UtilityDetailActions } from '../../../../../store/utilityDetails'
import { AppDispatch, RootState } from '../../../../../store'
import { AppActions } from '../../../../../store/app'
import { MapRefProps } from '../../../../../views/Main'
import { WaterSystemCoordinatesSelector } from '../../../../../store/publicWaterSystem'
import { WaterSystemsActions, WaterSystemsSelector } from '../../../../../store/waterSystems'
import { useEffect, useRef } from 'react'

interface UtilityCardWidgetProps {
  //waterSystems: IWaterSystemWCoordinates[]
  mapRef: React.MutableRefObject<MapRefProps | null>
  sortOrder: string
}

const UtilityCardWidget: React.FC<UtilityCardWidgetProps> = ({
  //waterSystems,
  sortOrder,
  mapRef,
}) => {
  const theme = useTheme()
  const dispatch = useDispatch<AppDispatch>()
  const refs = useRef<any[]>([])
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const selectedWaterSystem = useSelector(WaterSystemsSelector.getSelectedWaterSystem)
  const waterSystems = useSelector((state:RootState)=>WaterSystemCoordinatesSelector.makeSortedCoordinates(state, sortOrder))

  const handleMoveEnd = (system) => {

    if (!mapRef?.current || !mapRef.current?.map || !system.COORDINATES?.location ) {return}
    const _map = mapRef.current!.map!
    const { lng, lat } = system.COORDINATES.location
    const markerPosition = _map.project([lng, lat])
    dispatch(
      MapActions.setPopupDetail({
        position: {
          x: markerPosition.x,
          y: markerPosition.y + 10,
        },
        details: system,
        fillColor: getViolationColor(system.VIOLATIONS_COUNT, theme),
        visible: true,
        timeout: 10000
      })
    )
  }
  const handleClick = (system: IWaterSystemWCoordinates) => {
    dispatch(WaterSystemsActions.setSelectedWaterSystem(system.PWSID))
    dispatch(MapActions.setPopupDetail({ visible: false }))

    if (!mapRef?.current || !mapRef.current?.map || !system.COORDINATES?.location) return
    const _map = mapRef.current!.map!
    const { lng, lat } = system.COORDINATES.location
    //debouncedFlyTo(lng, lat);

    _map.flyTo({
      center: [lng, lat],
      zoom: 12,
      duration: 1500,
    })
    _map.once('moveend', () => handleMoveEnd(system))
    if(isMobile) {
      dispatch(AppActions.setMapDataDrawerOpen(false))
    }
  }

  const handleClickView= async (e,system) => {

    e.preventDefault()
    e.stopPropagation()
    dispatch(UtilityDetailActions.openDrawer())
    if(isMobile) {
      dispatch(AppActions.setMapDataDrawerOpen(false))
    }
    dispatch(WaterSystemsActions.setSelectedWaterSystem(system.PWSID))
    if (mapRef?.current && mapRef.current?.map && system.COORDINATES?.location) {
      const _map = mapRef.current!.map!

      const { lng, lat } = system.COORDINATES.location
      //debouncedFlyTo(lng, lat);

      _map.flyTo({
        center: [lng, lat],
        zoom: 12,
        duration: 1500,
      })

      if(!isMobile) {
        _map.once('moveend', ()=>handleMoveEnd(system))
      }
    }
    // move this to the detail slot
    await dispatch(UtilityDetailActions.fetchUtilityDetailsAsync(system.PWSID))
  }

  useEffect(() => {
    const currentSystemCard = refs.current.find(r => r &&  r.getAttribute('data-pwsid') === selectedWaterSystem)

    if(currentSystemCard && !isMobile) {
     // currentSystemCard.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" })
    }
  }, [selectedWaterSystem])

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: '#FFF',
        padding: '0.1rem',
      }}
    >
      {waterSystems.map((system, index) => (
        <Box
          key={system._id}
          data-pwsid={system.PWSID}
          ref={(el) => (refs.current[index] = el)}

          sx={{

            p: 0,
            //mx: '-1rem',
            my: 0,
          }}
        >
          <Box
            //p={1}
            //onMouseEnter={() => handleMouseEnter(system)}
            //onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(system)}
            sx={{
              background: (theme) => selectedWaterSystem === system.PWSID ? theme.palette.grey[100] : "#FFF",
              borderRadius: (theme) => theme.shape.borderRadius,
              border: '1px solid transparent',
              transition: 'all 0.2s ease',
              cursor: 'pointer',
              p: 1,
              '&:hover': {
                border: `1px solid ${theme.palette.grey[300]}`,
                backgroundColor: theme.palette.grey[200],
                borderRadius: '0.5rem',
              },
            }}
          >
            <Stack
              direction={{ xs: 'row' }}
              justifyContent="flex-start"
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              spacing={2}
              sx={{ width: '100%' }}
            >
              <Typography
                fontSize="0.875rem"
                fontWeight="bold"
                color="textPrimary"
                sx={{ textAlign: { xs: 'left', sm: 'left' }, fontWeight: 600, width: '80%' }}
              >
                {system.PWS_NAME}
              </Typography>

              <Box sx={{ marginLeft: 'auto', cursor: 'pointer' }}>
                <Button
                  startIcon={<ExpandIcon/>}
                  onClick={(e) => handleClickView(e,system)}
                  size="small"
                  sx={{
                    textTransform: 'none',
                    '&:hover':{
                      backgroundColor:'inherit',
                      opacity: 0.7
                    }
                  }}
                >
                  View
                </Button>
              </Box>
            </Stack>

            <Typography
              fontSize="0.875rem"
              fontWeight="500"
              color={theme.palette.text.secondary}
              sx={{ width: '90%' }}
            >
              {system.COORDINATES?.formatted_address}
            </Typography>

            <Stack direction="row" alignItems="center" spacing={1}>
              <UsersGroupIcon fillColor={theme.palette.primary.main} />
              <Typography fontSize="0.875rem" fontWeight="500" color={theme.palette.text.secondary}>
                {system.POPULATION_SERVED_COUNT?.toLocaleString() || ''} served
              </Typography>
            </Stack>

            <Box sx={{ mt: 0.7 }}>
              <Typography
                component="span"
                sx={{
                  backgroundColor: theme.palette.info.light,
                  color: theme.palette.primary.main,
                  padding: '0.15rem 0.60rem',
                  borderRadius: '1rem',
                  fontSize: '0.75rem',
                  fontWeight: 500,
                  display: 'inline-flex',
                  alignItems: 'center',
                  '&::before': {
                    content: '""',
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: 'currentColor',
                    display: 'inline-block',
                    marginRight: '4px',
                  },
                }}
              >
                {system.PWS_TYPE_CODE}
              </Typography>
            </Box>
          </Box>

          {index !== waterSystems.length - 1 && <Divider sx={{ mt: 1.5, mb: 1 }} />}
        </Box>
      ))}
    </Box>
  )
}

export default UtilityCardWidget
